export { default as InventoryReplenishmentSlot } from './InventoryReplenishmentSlot';
